import { render } from "./LiveAttendanceView.vue?vue&type=template&id=ddda427a"
import script from "./LiveAttendanceView.vue?vue&type=script&lang=js"
export * from "./LiveAttendanceView.vue?vue&type=script&lang=js"

import "./LiveAttendanceView.vue?vue&type=style&index=0&id=ddda427a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__